import {bindAsyncAction} from '../../utils/sagas';
import {fetchContracts} from './actions';
import {login} from '../auth/actions';
import {apiRequest} from '../../utils/api';
import {call, take} from 'redux-saga/effects';
import {logoutButtonClick} from '../../components/Auth/actions';

const worker = bindAsyncAction(
  fetchContracts,
  function* getDevices(params) {
    return yield call(apiRequest, params);
  }
);

export default function* contractsSaga() {
  while (true) {
    yield take(login.done.type);
    try {
      yield call(worker, {
        url: '/api/v2/contracts',
      });
    } catch (e) {
      return;
    }
    yield take(logoutButtonClick.type)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/contracts/index.js